import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class AskExpertProfessionalService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                public fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.ASK_EXPERT_PROFESSIONAL(), data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.ASK_EXPERT_PROFESSIONAL(id));
    }

    followUp(id, data): Observable<any> {
        return this.putRequest(AppUrl.FOLLOW_UP_ASK_EXPERT_PROFESSIONAL(id), data);
    }

    assignCounsellor(id, data): Observable<any> {
        return this.putRequest(AppUrl.ASSIGN_COUNSELLOR_ASK_EXPERT_PROFESSIONAL(id), data);
    }
}
